<mat-nav-list>
  <ng-container>
    <a mat-list-item class="hamburger" [ngClass]="{'border-bottom-element': isClicked}" routerLinkActive="active" (click)="toggleMenu()">
      <div class="trigger" [ngClass]="{'isClicked': isClicked}">
        <div class="line line1" ></div>
        <div class="line" ></div>
        <div class="line line2" ></div>
      </div>
    </a>
  </ng-container>
  <ng-container *ngFor="let item of menuItems">
    <a mat-list-item class="{{item.icon}}" 
      [ngClass]="{
        'border-bottom-element': isClicked,
        'un-login-user': (!isLogin && item.role === role.roleCCJAdmin)
      }"
      [routerLink]="[item.link]"
      routerLinkActive="active"
    >
      <mat-icon class="icon" aria-hidden="false" [svgIcon]="item.icon"></mat-icon>
      <span [hidden]="collapse" class="pl-3">{{item.title}}</span>
    </a>
  </ng-container>
</mat-nav-list>